import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { CertificateService } from '@/services/certificate-auth/certificate.service';
import { ButtonCertificateComponent } from './button-certificate.component';

@NgModule({
    imports: [CommonModule],
    exports: [ButtonCertificateComponent],
    declarations: [ButtonCertificateComponent],
    // providers: [CertificateService]
})
export class ButtonCertificateModule {}
